import React, {useEffect, useState} from "react";
import {withRouter} from "react-router-dom";
import {useFiltered} from "@atttomyx/shared-hooks";
import {CircularProgress, IconButton, Typography} from "@mui/material";
import {
    ContentCopy as CloneIcon,
    Delete as DeleteIcon,
    Edit as EditIcon,
    Visibility as PreviewIcon,
} from "@mui/icons-material";
import {Cards, ConfirmDeleteDialog, FiltersAccordion, FloatingAddButton} from "@atttomyx/react-components";
import {TemplateCard} from "../cards";
import {PreviewHtmlDialog} from "../dialogs";
import {TemplateFilters} from "../filters";
import {templateService} from "../../services";
import {sorting} from "@atttomyx/shared-utils";
import {confirm} from "@atttomyx/react-utils";

const TemplatesPage = (props) => {
    const { snackbar, dimensions, templates, filters, onDelete, onCopy, onGotoAdd, onGotoEdit } = props;
    const [ template, setTemplate ] = useState(null);
    const [ preview, setPreview ] = useState(null);
    const [ cloning, setCloning ] = useState(null);
    const [ showDelete, setShowDelete ] = useState(false);
    const [ showFilters, setShowFilters ] = useState(false);
    const filtered = useFiltered(templates, filters, sorting.sortByOrder);

    useEffect(() => {
        if (cloning) {
            const success = (result) => {
                snackbar.setSuccess("Template copied");
                setCloning(null);
                onCopy(result);
            };

            const failure = (err) => {
                snackbar.setError(err);
                setCloning(null);
            };

            templateService.cloneTemplate(cloning.id, success, failure);
        }
    }, [cloning]);

    return <div className="templates-page">
        <Typography variant="h5" paragraph={true}>
            Templates
        </Typography>
        <div className="field">
            <FiltersAccordion
                filters={filters}
                form={TemplateFilters}
                open={showFilters}
                onOpen={() => setShowFilters(true)}
                onClose={() => setShowFilters(false)}
            />
        </div>
        <Cards
            items={filtered}
            paging={filters.paging}
            dimensions={dimensions}
            renderer={(item) =>
                <TemplateCard
                    key={item.id}
                    template={item}
                    filters={filters}
                >
                    <IconButton color="secondary" title="Delete" className="delete"
                                onClick={() => {
                                    setTemplate(item);
                                    setShowDelete(true);
                                }}>
                        <DeleteIcon/>
                    </IconButton>
                    {cloning && cloning.id === item.id ?
                        <CircularProgress size="18px"/> :
                        <IconButton color="primary" title="Copy"
                                    onClick={() => confirm.confirm(
                                        `Are you sure you want to make a copy of ${item.name}?`,
                                        () => setCloning(item))}>
                            <CloneIcon/>
                        </IconButton>}
                    <IconButton
                        color="primary" title="Preview"
                        onClick={() => setPreview(item.content)}
                    >
                        <PreviewIcon/>
                    </IconButton>
                    <IconButton
                        color="primary" title="Edit"
                        onClick={() => onGotoEdit(item.id)}
                    >
                        <EditIcon/>
                    </IconButton>
                </TemplateCard>}
        />
        <FloatingAddButton
            title="Add template"
            position={dimensions.portrait ? "higher" : undefined}
            center={false}
            onClick={onGotoAdd}
        />
        {showDelete && template ?
            <ConfirmDeleteDialog
                snackbar={snackbar}
                title={template.name}
                onCancel={() => {
                    setShowDelete(false);
                    setTemplate(null);
                }}
                onDelete={(templateId) => {
                    setShowDelete(false);
                    setTemplate(null);
                    onDelete(templateId);
                }}
                deleter={(success, failure) => templateService.deleteTemplate(template.id, success, failure)}
            /> : null}
        {preview ?
            <PreviewHtmlDialog
                html={preview}
                onCancel={() => setPreview(null)}
            /> : null}
    </div>
}

export default withRouter(TemplatesPage);
